import gql from "../gql";
const EarnedStamp = gql `
  fragment EarnedStamp on StampEarned {
    __typename
    rewardId
    kind
    apiName
    name
    description
    eventDate
    eventLocation
    iconUrl
    linkUrl
  }
`;
export default gql `
  fragment EarnedStamps on StampEarnedConnection {
    __typename
    count
    totalCount
    edges {
      __typename
      cursor
      node {
        ...EarnedStamp
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ${EarnedStamp}
`;
